export default "__VITE_ASSET__0ab05293__"